import React from 'react';
import style from './style.module.scss';
import MoreInformation from '@components/more-information';

const SiteDetailsMoreInfo = ({ moreInfoDataPointsMap }) => {
  return (
    <div className={style.addMarginBottom}>
      <MoreInformation
        info={Object?.keys(moreInfoDataPointsMap)?.map((a) => {
          return {
            title: moreInfoDataPointsMap[a]?.value || null,
            heading: moreInfoDataPointsMap[a]?.title || null
          };
        })}
        hideEditBtn
      />
    </div>
  );
};

export default SiteDetailsMoreInfo;
